import template from './filter-map-list.html.twig';
import '../../component/filter-map-form';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-es-filter-map-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            items: null,
            isLoading: true,
            sortBy: 'searchTerm',
            sortDirection: 'ASC',
            limit: 25,
            activeModal: false,
            currentEntity: null,
            showDeleteModal: false,
            itemToDelete: null,
        };
    },

    computed: {
        deleteConfirmText() {
            if (!this.itemToDelete) return '';
            return this.$t('TopdataEnhancedSearchSW6.topdata-es-filter-map.deleteConfirmText', {
                searchTerm: this.itemToDelete.searchTerm,
                blockedTerm: this.itemToDelete.blockedTerm,
            });
        },

        repository() {
            return this.repositoryFactory.create('tdes_search_filter');
        },

        columns() {
            return [{
                property: 'searchTerm',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.columnSearchTerm'),
                allowResize: true,
                primary: true,
                sortable: true,
            }, {
                property: 'blockedTerm',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.columnBlockedTerm'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'createdAt',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.columnCreatedAt'),
                allowResize: true,
                sortable: true,
            }];
        },

    },

    mounted() {
        this.getList();
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));

            this.repository.search(criteria).then((result) => {
                this.total = result.total;
                this.items = result;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onPageChange(params) {
            this.page = params.page;
            this.limit = params.limit;
            this.getList();
        },

        onSortColumn(column) {
            this.sortBy = column.dataIndex ?? column.property;
            this.sortDirection = column.sortDirection ?? 'ASC';
            this.getList();
        },

        onAddFilter() {
            this.currentEntity = this.repository.create();
            this.currentEntity.searchTerm = '';
            this.currentEntity.blockedTerm = '';
            this.currentEntity.salesChannelId = null;
            this.activeModal = true;
        },

        onEditFilter(item) {
            this.repository.get(item.id).then((entity) => {
                this.currentEntity = entity;
                this.activeModal = true;
            });
        },

        onCloseModal() {
            this.activeModal = false;
            this.currentEntity = null;
            this.getList();
        },

        onShowDeleteModal(item) {
            this.itemToDelete = item;
            this.showDeleteModal = true;
        },

        onCloseDeleteModal() {
            this.showDeleteModal = false;
            this.itemToDelete = null;
        },

        onConfirmDelete() {
            this.repository.delete(this.itemToDelete.id).then(() => {
                this.createNotificationSuccess({
                    message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-filter-map.deleteSuccess'),
                });
                this.onCloseDeleteModal();
                this.getList();
            }).catch(() => {
                this.onCloseDeleteModal();
            });
        },
    },
});